import { render } from "./HelloWorld.vue?vue&type=template&id=52e4ef9c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=52e4ef9c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-52e4ef9c"

export default script